import { SituacaoEnum } from '@/utils/enumerados';
import { isPrazoRecursalVencido } from '@/utils/businessDays';

/**
 * Situações padrão (não consolidada): manifestação disponível após julgamento e habilitação.
 * (Modelo recomendado — IN SEGES/ME 73/2022 e Lei 14.133/2021 art. 165 §1º).
 */
const SITUACOES_MANIFESTACAO_PADRAO = Object.freeze([
  SituacaoEnum.HABILITACAO,
  SituacaoEnum.JULGAMENTO,
]);

/**
 * Situação da manifestação consolidada em etapa própria — habilitada apenas quando
 * o edital previu expressamente e o pregoeiro definiu o prazo da etapa.
 */
const SITUACAO_MANIFESTACAO_CONSOLIDADA = SituacaoEnum.MANIFESTACAO_INTENCAO_RECURSO;

const isConsolidada = auction => Boolean(auction?.manifestacao_intencao_consolidada);

const prazoManifestacaoVigente = (prazoManifestacao, now = new Date()) => {
  if (!prazoManifestacao?.definidos) return false;
  if (!prazoManifestacao.dataLimite) return false;
  return !isPrazoRecursalVencido(prazoManifestacao.dataLimite, now);
};

/**
 * Situações onde o botão "Manifestar Intenção de Recurso" deve ser exibido.
 * Regras:
 * - Consolidada: apenas na situação 20 (MANIFESTACAO_INTENCAO_RECURSO) e com prazo definido e vigente.
 * - Padrão: nas situações 9 (HABILITACAO) e 19 (JULGAMENTO).
 * Sempre restrito ao papel LICITANTE.
 */
export const situacoesVisibilidadeIntencaoRecurso = ({
  auction,
  prazoManifestacao,
  now = new Date(),
} = {}) => {
  if (isConsolidada(auction)) {
    return prazoManifestacaoVigente(prazoManifestacao, now)
      ? [SITUACAO_MANIFESTACAO_CONSOLIDADA]
      : [];
  }
  return [...SITUACOES_MANIFESTACAO_PADRAO];
};

export const isSituacaoVisibilidadeIntencaoRecurso = ({
  auction,
  situacao,
  prazoManifestacao,
  now = new Date(),
} = {}) => {
  if (situacao === null || situacao === undefined) return false;
  const situacoes = situacoesVisibilidadeIntencaoRecurso({ auction, prazoManifestacao, now });
  return situacoes.includes(Number(situacao));
};

/**
 * Regra completa para exibir o botão — deve ser LICITANTE e estar em situação válida.
 */
export const podeExibirBotaoIntencaoRecurso = ({
  auction,
  situacao,
  prazoManifestacao,
  isBidder,
  now = new Date(),
} = {}) => {
  if (!isBidder) return false;
  return isSituacaoVisibilidadeIntencaoRecurso({ auction, situacao, prazoManifestacao, now });
};

export const SITUACOES_MANIFESTACAO_INTENCAO_PADRAO = SITUACOES_MANIFESTACAO_PADRAO;
export const SITUACAO_MANIFESTACAO_INTENCAO_CONSOLIDADA = SITUACAO_MANIFESTACAO_CONSOLIDADA;
